import {AxiosError, AxiosPromise, AxiosResponse} from 'axios';
import {
   CreateParams,
   DeleteManyParams,
   DeleteParams,
   DELETE_MANY,
   GetListParams,
   GetManyParams,
   GetManyReferenceParams,
   GetOneParams,
   HttpError,
   UpdateManyParams,
   UpdateParams,
   GET_MANY_REFERENCE
} from 'ra-core';
import {CREATE, DELETE, GET_LIST, GET_MANY, GET_ONE, UPDATE} from 'react-admin';
import {convertFileToBase64, convertAllToBase64} from '../components/utils/Convertor';
import {
   COLUMN,
   COLUMN_CATEGORY,
   COLUMN_HAIR_SERVICE,
   HASHTAGS_LIST_TYPES,
   HASHTAG_CATEGORY,
   HASHTAG_CATEGORY_LIST,
   HASHTAG_MULTIPLE_LIST,
   HASHTAG_RECOMMEND_LIST,
   INQUIRY,
   SALON,
   STYLE_POST,
   USER,
   REPORTS,
   KEYWORDS,
   NOTIFICATIONS,
   HASH_TAG,
   CAMPAIGN,
   VERSION, COUNTRY, CITY, AREA, SNAPSHOT, SNAPSHOT_HASHTAGS,
   SERVICES,
   SERVICES_CATEGORIES,
   COUNTRIES,
   CITIES,
   AREAS,
   CURRENCIES,
   IP_LISTS,
   IP_LIST_CONFIG,
   ADMIN_LOGS,
   APP_VERSIONS, SETTINGS, BONUS_TASK, BONUS_COUPON, BONUS_INFO_TAG, ADMIN_USER_CREDENTIALS, SMS_PROVIDERS
} from '../consts/Names';
import {Api} from '../service/API';
import {PathCreator} from '../service/RequestPath';

const EXPORT_LIST = 'EXPORT_LIST';

type Params =
   | GetListParams
   | (GetListParams & GetManyParams)
   | GetOneParams
   | GetManyParams
   | GetManyReferenceParams
   | UpdateParams
   | UpdateManyParams
   | CreateParams
   | DeleteParams
   | DeleteManyParams;

const convertDataProviderRequestToHTTP = (type: string, resource: string, params: Params): AxiosPromise<any> => {
   if (resource === 'version') {
      return Api.GetAPIVersion();
   }
   console.log(type, resource, params)
   switch (type) {
      case GET_MANY:
      case GET_LIST: {
         let param = params as GetListParams;
         if (NOTIFICATIONS.SOURCE === resource) {
            return Api.GetList(PathCreator.NOTIFICATION_PATH, param);
         }
         if (HASHTAG_MULTIPLE_LIST.SOURCE === resource) {
            return Api.GetList(PathCreator.HASHTAG_LISTS_PATH + '/multiple', param);
         }
         if (HASHTAG_CATEGORY_LIST.SOURCE === resource) {
            return Api.GetList(PathCreator.HASHTAG_LISTS_PATH + '/category', param);
         }
         if (HASH_TAG.SOURCE === resource) {
            return Api.GetList(PathCreator.HASHTAGS_PATH, param);
         }
         if (REPORTS.SOURCE === resource) {
            return Api.GetList(PathCreator.REPORTS_PATH, param);
         }
         if (HASHTAG_RECOMMEND_LIST.SOURCE === resource) {
            return Api.GetList(PathCreator.HASHTAG_LISTS_PATH + '/recommend', param);
         }
         if (USER.SOURCE === resource && type === GET_MANY) {
            return Api.GetManyUsers(PathCreator.USERS_PATH + '/many', params);
         }
         if (USER.STYLIST_SOURCE === resource && type === GET_MANY) {
            return Api.GetManyUsers(PathCreator.USERS_PATH + '/many', params);
         }
         if (COLUMN_CATEGORY.SOURCE === resource) {
            return Api.GetList(PathCreator.COLUMN_CATEGORIES_PATH, param);
         }
         if (COLUMN_HAIR_SERVICE.SOURCE === resource) {
            return Api.GetList(PathCreator.COLUMN_HAIR_SERVICE_PATH + '/all', param);
         }
         if (COLUMN.SOURCE === resource) {
            return Api.GetList(PathCreator.COLUMNS_PATH, param);
         } 
         if (ADMIN_LOGS.SOURCE === resource) {
            return Api.GetList(PathCreator.ADMIN_LOGS_PATH, param);
         }

         if (INQUIRY.SOURCE === resource) {
            return Api.GetList(PathCreator.CONTACT_PATH + '/get', param);
         }
         if (KEYWORDS.SOURCE === resource) {
            return Api.GetList(PathCreator.GetPathBySource(resource) + '/all', param);
         }
         if (STYLE_POST.SOURCE === resource  && type === GET_MANY) {
            return Api.GetManyStylePosts(PathCreator.STYLE_POST_LIST_PATH + '/many', param);
         }
         if (STYLE_POST.SOURCE === resource) {
            return Api.GetStylePostList(PathCreator.STYLE_POST_LIST_PATH, param);
         }
         if (SNAPSHOT.SOURCE === resource) {
            return Api.GetList(PathCreator.GetPathBySource(resource), param);
         }
         if (BONUS_TASK.SOURCE === resource) {
            return Api.GetList(PathCreator.GetPathBySource(resource) + '/all', param);
         }
         if (BONUS_INFO_TAG.SOURCE === resource) {
            return Api.GetList(PathCreator.GetPathBySource(resource) + '/all', param);
         }
         if (BONUS_COUPON.SOURCE === resource) {
            return Api.GetList(PathCreator.GetPathBySource(resource) + '/all', param);
         }
         if (SNAPSHOT_HASHTAGS.SOURCE === resource) {
            return Api.GetList(PathCreator.GetPathBySource(resource), param);
         }
         if (CAMPAIGN.SOURCE === resource) {
            return Api.GetCampaign(PathCreator.CAMPAIGN_PATH + '/latest');
         }

         if (VERSION.SOURCE === resource) {
            return Api.GetAdminVersion(PathCreator.ADMIN_VERSION_PATH).then(response => ({data: [{...response.data, id: 1}]}));
         }
         if (IP_LIST_CONFIG.SOURCE === resource) {
            return Api.GetList(PathCreator.IP_LIST_CONFIG_PATH, param);
         }
         if (SETTINGS.SOURCE === resource) {
            return Api.GetList(PathCreator.SETTINGS_PATH, param);
         }
         if (SERVICES_CATEGORIES.SOURCE === resource) {
            return Api.GetList(PathCreator.SERVICES_CATEGORIES_PATH+'/all' , param);
         } 
         if (SERVICES.SOURCE === resource) {
            return Api.GetList(PathCreator.SERVICES_PATH+'/all' , param);
         } 

         if (COUNTRIES.SOURCE === resource) {
            return Api.GetList(PathCreator.COUNTRIES_PATH+'/all' , param);
         } 
         if (CITIES.SOURCE === resource) {
            return Api.GetList(PathCreator.CITIES_PATH+'/all' , param);
         }
         if (SMS_PROVIDERS.SOURCE === resource) {
            return Api.GetList(PathCreator.SMS_PROVIDERS_PATH+'/all' , param);
         }
         if (ADMIN_USER_CREDENTIALS.SOURCE === resource) {
            return Api.GetList(PathCreator.ADMIN_USER_CREDS_PATH+'/all' , param);
         }
         if (AREAS.SOURCE === resource) {
            return Api.GetList(PathCreator.AREAS_PATH+'/all' , param);
         }   
         if (CURRENCIES.SOURCE === resource) {
            return Api.GetList(PathCreator.CURRENCIES_PATH+'/all' , param);
         }
         if (APP_VERSIONS.SOURCE === resource) {
            return Api.GetList(PathCreator.APP_VERSIONS_PATH , param);
         }
         if (IP_LISTS.SOURCE === resource) {
            return Api.GetList(PathCreator.IP_LISTS_PATH+'/all' , param);
         }
         return Api.GetList(PathCreator.GetPathBySource(resource), param);
      }

      case EXPORT_LIST: {
         let param = params as GetListParams;
         let idsParams = params as GetManyParams;
         return Api.ExportList(PathCreator.GetPathBySource(resource) + '/export', param, idsParams);
      }

      case GET_MANY_REFERENCE: {
         if (STYLE_POST.SOURCE === resource) {
            return Api.GetListStylePosts(PathCreator.USERS_PATH, params);
         }
         if (SERVICES.SOURCE === resource) {
            let r = Api.GetServicesByCategory(PathCreator.SERVICES_PATH + '/all', params)
            console.log(r, params)
            return r;
         }
         if (REPORTS.SOURCE === resource) {
            const {target} = params as any;
            if (target === 'userReports') return Api.GetReferenceList(PathCreator.REPORT_PATH_USER, params);
            return Api.GetReferenceList(PathCreator.REPORT_PATH_POST, params);
         }
         if (CITIES.SOURCE === resource) {
            return Api.GetCitiesByCountry(PathCreator.CITIES_PATH + '/all', params);
         }
         if (AREAS.SOURCE === resource) {

            return Api.GetAreasByCity(PathCreator.AREAS_PATH + '/all', params);
         }
         break;
      }
      case GET_ONE: {
         let param = params as GetOneParams;
         if (isNaN(Number(param.id))) break;

         if (SALON.SOURCE === resource) {
            return Api.GetOneSalon(PathCreator.USERS_PATH, param);
         }
         if (COLUMN.SOURCE === resource) {
            return Api.GetOne(PathCreator.COLUMN_PATH, param).then(response => {
               response.data.author_photo = {author_photo: response.data.author_photo};
               return response;
            });
         }
         if (COLUMN_CATEGORY.SOURCE === resource) {
            return Api.GetOne(PathCreator.COLUMN_CATEGORY_PATH, param);
         }
         if (COLUMN_HAIR_SERVICE.SOURCE === resource) {
            return Api.GetOne(PathCreator.COLUMN_HAIR_SERVICE_PATH, param);
         }
         if (BONUS_TASK.SOURCE === resource) {
            return Api.GetOne(PathCreator.BONUS_TASKS_PATH, param);
         }
         if (BONUS_INFO_TAG.SOURCE === resource) {
            return Api.GetOne(PathCreator.BONUS_INFO_TAG, param);
         }

         if (BONUS_COUPON.SOURCE === resource) {
            return Api.GetOne(PathCreator.BONUS_COUPON_PATH, param);
         }

         if (SNAPSHOT.SOURCE === resource) {
            return Api.GetOne(PathCreator.SNAPSHOT_PATH, param);
         }
         if (HASHTAG_CATEGORY.SOURCE === resource) {
            let listParam: GetListParams = {
               filter: param,
               pagination: {page: -1, perPage: -1},
               sort: {field: '', order: ''}
            };
            return Api.GetList(PathCreator.GetPathBySource(resource), listParam);
         }
         if (NOTIFICATIONS.SOURCE === resource) {
            let listParam: GetListParams = {
               filter: param,
               pagination: {page: -1, perPage: -1},
               sort: {field: '', order: ''}
            };
            return Api.GetList(PathCreator.NOTIFICATION_PATH, listParam);
         }
         if (INQUIRY.SOURCE === resource) {
            let listParam: GetListParams = {
               filter: param,
               pagination: {page: -1, perPage: -1},
               sort: {field: '', order: ''}
            };
            return Api.GetList(PathCreator.CONTACT_PATH + '/get', listParam);
         }
         if (KEYWORDS.SOURCE === resource) {
            return Api.GetOne(PathCreator.GetPathBySource(resource) + '/get', param);
         }
         if (CAMPAIGN.SOURCE === resource) {
            return Api.GetCampaign(PathCreator.CAMPAIGN_PATH + '/latest').then(response => {
               response.data.app_banner = {
                  src : response.data.app_banner
               }
               response.data.website_banner = {
                  src : response.data.website_banner
               }
               if (response.data.country_segmentation === null) { 
                  response.data.country_segmentation_active = false;
               } else {
                   response.data.country_segmentation_active = true;
               }
               return response;
            });
         }
         if (SERVICES.SOURCE === resource) {
            console.log(param)
            return Api.GetOne(PathCreator.SERVICES_PATH , param);
         } 
        if (COUNTRIES.SOURCE === resource) {
            return Api.GetOne(PathCreator.COUNTRIES_PATH , param).then(response => {
               response.data.flag = {
                  src : response.data.flag
               }
               return response;
            });    
         } 
         if (CITIES.SOURCE === resource) {
            return Api.GetOne(PathCreator.CITIES_PATH , param);
         }
         if (SMS_PROVIDERS.SOURCE === resource) {
            return Api.GetOne(PathCreator.SMS_PROVIDERS_PATH , param);
         }
         if (ADMIN_USER_CREDENTIALS.SOURCE === resource) {
            return Api.GetOne(PathCreator.ADMIN_USER_CREDS_PATH , param);
         }
         if (AREAS.SOURCE === resource) {
            return Api.GetOne(PathCreator.AREAS_PATH , param);
         }
         if (CURRENCIES.SOURCE === resource) {
            return Api.GetOne(PathCreator.CURRENCIES_PATH , param);
         }
         if (IP_LISTS.SOURCE === resource) {
            return Api.GetOne(PathCreator.IP_LISTS_PATH , param);
         }
         if (VERSION.SOURCE === resource) {
            return Api.GetAdminVersion(PathCreator.ADMIN_VERSION_PATH).then(response => ({data: {...response.data, id: 1}}));
         }

         if (IP_LIST_CONFIG.SOURCE === resource) {
            return Api.GetOne(PathCreator.IP_LIST_CONFIG_PATH, param);
         }    
         if (SETTINGS.SOURCE === resource) {
            return Api.GetOne(PathCreator.SETTINGS_PATH, param);
         }

         return Api.GetOne(PathCreator.GetPathBySource(resource), param);
      }
      case CREATE: {
         let param = params as CreateParams;
         if (NOTIFICATIONS.SOURCE === resource) {
            return Api.CreateNotification(PathCreator.NOTIFICATION_PATH, param);
         }
         if (HASHTAG_MULTIPLE_LIST.SOURCE === resource) {
            return Api.CreateMultipleList(PathCreator.HASHTAG_LISTS_PATH, param);
         }
         if (HASHTAG_RECOMMEND_LIST.SOURCE === resource) {
            return Api.CreateRecommendList(PathCreator.HASHTAG_LISTS_PATH, param);
         }
         if (COLUMN_CATEGORY.SOURCE === resource) {
            return convertFileToBase64(param.data?.image).then((base64Picture) => {
               param.data.image = base64Picture;
               return Api.CreateItem(PathCreator.COLUMN_CATEGORY_PATH, param);
            });
         }
         if (COLUMN_HAIR_SERVICE.SOURCE === resource) {
             return Api.CreateItem(PathCreator.COLUMN_HAIR_SERVICE_PATH + '/add', param);
         }
         if (HASHTAG_CATEGORY_LIST.SOURCE === resource) {
            if (param.data?.image?.rawFile)
               return convertFileToBase64(param.data?.image).then((base64Picture) => {
                  param.data.image = base64Picture;
                  return Api.CreateCategoryList(PathCreator.GetPathBySource(resource), param);
               });
            return Api.CreateCategoryList(PathCreator.GetPathBySource(resource), param);
         }
         if (COLUMN.SOURCE === resource) {
            if(param.data.author_photo && param.data.author_photo.rawFile) {
               return convertFileToBase64(param.data.author_photo).then((base64Picture) => {
                  param.data.author_photo = base64Picture;
                  return convertAllToBase64(param, Api.CreateItem, PathCreator.COLUMN_PATH);
               })
            }
            return convertAllToBase64(param, Api.CreateItem, PathCreator.COLUMN_PATH);
         }
         if (HASHTAG_CATEGORY.SOURCE === resource)
            return convertFileToBase64(param.data?.image).then((base64Picture) => {
               param.data.image = base64Picture;
               return Api.CreateItem(PathCreator.GetPathBySource(resource), param);
            });
         if (KEYWORDS.SOURCE === resource) {
            return Api.CreateItem(PathCreator.GetPathBySource(resource) + '/add', param);
         }
         if (BONUS_INFO_TAG.SOURCE === resource) {
            return Api.CreateItem(PathCreator.GetPathBySource(resource) + '/add', param);
         }
         if (SNAPSHOT.SOURCE === resource) {
            // return Api.CreateItem(PathCreator.SNAPSHOT_PATH, param);
            getHashTags(param);
            return convertAllToBase64(param, Api.CreateItem, PathCreator.SNAPSHOT_PATH);
         }
         if (SERVICES_CATEGORIES.SOURCE === resource) {
            return Api.CreateItem(PathCreator.SERVICES_CATEGORIES_PATH+'/add' , param);
         } 
         if (SERVICES.SOURCE === resource) {
            return Api.CreateItem(PathCreator.SERVICES_PATH+'/add' , param);
         } 

         if (COUNTRIES.SOURCE === resource) {
            if (param.data?.flag?.rawFile === undefined) {
               delete param.data.flag;
               return Api.CreateItem(PathCreator.COUNTRIES_PATH+'/add' , param);
            }
            
            return convertFileToBase64(param.data?.flag).then((base64Picture) => {
               param.data.flag = base64Picture;
               return Api.CreateItem(PathCreator.COUNTRIES_PATH+'/add' , param);
            });
         } 
         if (BONUS_TASK.SOURCE === resource) {
            if (param.data?.disabled_image?.rawFile === undefined && param.data?.image?.rawFile === undefined) {

               return Api.CreateItem(PathCreator.BONUS_TASKS_PATH+'/' , param);
            } else if (param.data?.image?.rawFile !== undefined && param.data?.disabled_image?.rawFile === undefined) {

               return convertFileToBase64(param.data?.image).then((base64Picture) => {
                  param.data.image.source = base64Picture;
                  return Api.CreateItem(PathCreator.BONUS_TASKS_PATH+'/' , param);
               });
            } else if (param.data?.disabled_image?.rawFile !== undefined && param.data?.image?.rawFile === undefined) {

               return convertFileToBase64(param.data?.disabled_image).then((base64Picture) => {

                  param.data.disabled_image.source = base64Picture;
                  return Api.CreateItem(PathCreator.BONUS_TASKS_PATH+'/' , param);
               });
            } else {

               return convertFileToBase64(param.data?.disabled_image).then((base64Picture) => {

                  param.data.disabled_image.source = base64Picture;
                  return convertFileToBase64(param.data?.image).then((base64Picture) => {
                     console.log(base64Picture)

                     param.data.image.source = base64Picture;
                     return Api.CreateItem(PathCreator.BONUS_TASKS_PATH + '/', param);
                  })
               });
            }
         } 
         if (CITIES.SOURCE === resource) {
            return Api.CreateItem(PathCreator.CITIES_PATH+'/add' , param);
         }
         if (ADMIN_USER_CREDENTIALS.SOURCE === resource) {
            return Api.CreateItem(PathCreator.ADMIN_USER_CREDS_PATH+'/add' , param);
         }
         if (AREAS.SOURCE === resource) {
            return Api.CreateItem(PathCreator.AREAS_PATH+'/add' , param);
         }
         if (CURRENCIES.SOURCE === resource) {
            return Api.CreateItem(PathCreator.CURRENCIES_PATH+'/add' , param);
         } 
         if (IP_LISTS.SOURCE === resource) {
            return Api.CreateItem(PathCreator.IP_LISTS_PATH+'/add' , param);
         }
         return Api.CreateItem(PathCreator.GetPathBySource(resource), param);
      }
      case DELETE_MANY: {
         let param = params as DeleteManyParams;
         if (COLUMN.SOURCE === resource) {
            return Api.DeleteMany(PathCreator.COLUMNS_DELETE_PATH, param);
         }
         if (ADMIN_USER_CREDENTIALS.SOURCE === resource) {
            return Api.DeleteMany(PathCreator.ADMIN_USER_CREDS_PATH+'/deleteMany' , param);
         }
         if (REPORTS.SOURCE === resource) {
            return Api.DeleteMany(PathCreator.REPORT_PATH_DELETE_MANY, param);
         }
         if (param.ids.length === 1) {
            // @ts-ignore
            return Api.DeleteOne(PathCreator.GetPathBySource(resource), {id: param.ids[0]});
         }
         break;
      }
      case DELETE: {
         let param = params as DeleteParams;
         if (isNaN(Number(param.id))) break;
         if (COLUMN_CATEGORY.SOURCE === resource) {
            return Api.DeleteOne(PathCreator.COLUMN_CATEGORY_PATH, param);
         }
         if (COLUMN_HAIR_SERVICE.SOURCE === resource) {
            return Api.DeleteOne(PathCreator.SERVICES_CATEGORIES_PATH+'/delete' , param);
         }
         if (NOTIFICATIONS.SOURCE === resource) {
            return Api.DeleteOne(PathCreator.NOTIFICATION_PATH, param);
         }
         if (BONUS_INFO_TAG.SOURCE === resource) {
            return Api.DeleteOne(PathCreator.NOTIFICATION_PATH, param);
         }
         if (REPORTS.SOURCE === resource) {
            return Api.DeleteOne(PathCreator.REPORT_PATH_DELETE, param);
         }
         if (SNAPSHOT.SOURCE === resource) {
            return Api.DeleteUser(PathCreator.GetPathBySource(resource), param);
         }
         if (KEYWORDS.SOURCE === resource) {
            return Api.DeleteOne(PathCreator.GetPathBySource(resource) + '/delete', param);
         }
         if (USER.SOURCE === resource || USER.STYLIST_SOURCE === resource) {
            return Api.DeleteUser(PathCreator.GetPathBySource(resource) + '/', param);
         }
         if (SERVICES_CATEGORIES.SOURCE === resource) {
            return Api.DeleteOne(PathCreator.SERVICES_CATEGORIES_PATH+'/delete' , param);
         } 
         if (SERVICES.SOURCE === resource) {
            return Api.DeleteOne(PathCreator.SERVICES_PATH+'/delete' , param);
         }
         if (COUNTRIES.SOURCE === resource) {
            return Api.DeleteOne(PathCreator.COUNTRIES_PATH+'/delete' , param);
         }
         if (ADMIN_USER_CREDENTIALS.SOURCE === resource) {
            return Api.DeleteOne(PathCreator.ADMIN_USER_CREDS_PATH+'/delete' , param);
         }
         if (CITIES.SOURCE === resource) {
            return Api.DeleteOne(PathCreator.CITIES_PATH+'/delete' , param);
         }
         if (AREAS.SOURCE === resource) {
            return Api.DeleteOne(PathCreator.AREAS_PATH+'/delete' , param);
         }
         if (CURRENCIES.SOURCE === resource) {
            return Api.DeleteOne(PathCreator.CURRENCIES_PATH+'/delete' , param);
         }  
         if (IP_LISTS.SOURCE === resource) {
            return Api.DeleteOne(PathCreator.IP_LISTS_PATH+'/delete' , param);
         }
         return Api.DeleteOne(PathCreator.GetPathBySource(resource), param);
      }

      case UPDATE: {
         let param = params as UpdateParams;

         if (SALON.SOURCE === resource) {
            return convertAllToBase64(param, Api.UpdateSalon, PathCreator.USERS_PATH);
         }
         if (SERVICES_CATEGORIES.SOURCE === resource) {
            return Api.UpdateItem(PathCreator.SERVICES_CATEGORIES_PATH+'/edit' , param);
         }
         if (BONUS_INFO_TAG.SOURCE === resource) {
            return Api.UpdateItem(PathCreator.BONUS_INFO_TAG+'/edit' , param);
         }
         if (BONUS_TASK.SOURCE === resource) {

            if (param.data?.disabled_image?.rawFile === undefined && param.data?.image?.rawFile === undefined) {

               return Api.UpdateItem(PathCreator.BONUS_TASKS_PATH+'/edit' , param);
            } else if (param.data?.image?.rawFile !== undefined && param.data?.disabled_image?.rawFile === undefined) {

               return convertFileToBase64(param.data?.image).then((base64Picture) => {
                  console.log(base64Picture)
                  param.data.image.source = base64Picture;
                  return Api.UpdateItem(PathCreator.BONUS_TASKS_PATH+'/edit' , param);
               });
            } else if (param.data?.disabled_image?.rawFile !== undefined && param.data?.image?.rawFile === undefined) {

               return convertFileToBase64(param.data?.disabled_image).then((base64Picture) => {

                  param.data.disabled_image.source = base64Picture;
                  return Api.UpdateItem(PathCreator.BONUS_TASKS_PATH+'/edit' , param);
               });
            } else {

               return convertFileToBase64(param.data?.disabled_image).then((base64Picture) => {

                  param.data.disabled_image.source = base64Picture;
                  return convertFileToBase64(param.data?.image).then((base64Picture) => {
                     console.log(base64Picture)

                     param.data.image.source = base64Picture;
                     return Api.UpdateItem(PathCreator.BONUS_TASKS_PATH + '/edit', param);
                  })
               });
            }
         }
         if (BONUS_COUPON.SOURCE === resource) {
            if (param.data?.image_file?.rawFile === undefined && param.data?.icon_file?.rawFile === undefined) {

               return Api.UpdateItem(PathCreator.BONUS_COUPON_PATH+'/edit' , param);
            } else if (param.data?.image_file?.rawFile !== undefined && param.data?.icon_file?.rawFile === undefined) {

               return convertFileToBase64(param.data?.image_file).then((base64Picture) => {
                  console.log(base64Picture)
                  param.data.image_file.source = base64Picture;
                  return Api.UpdateItem(PathCreator.BONUS_COUPON_PATH+'/edit' , param);
               });
            } else if (param.data?.icon_file?.rawFile !== undefined && param.data?.image_file?.rawFile === undefined) {

               return convertFileToBase64(param.data?.icon_file).then((base64Picture) => {

                  param.data.icon_file.source = base64Picture;
                  return Api.UpdateItem(PathCreator.BONUS_COUPON_PATH+'/edit' , param);
               });
            } else {

               return convertFileToBase64(param.data?.icon_file).then((base64Picture) => {

                  param.data.icon_file.source = base64Picture;
                  return convertFileToBase64(param.data?.image_file).then((base64Picture) => {
                     console.log(base64Picture)

                     param.data.image_file.source = base64Picture;
                     return Api.UpdateItem(PathCreator.BONUS_COUPON_PATH + '/edit', param);
                  })
               });
            }
         }
         if (SERVICES.SOURCE === resource) {
            return Api.UpdateItem(PathCreator.SERVICES_PATH+'/edit' , param);
         }
         
         if (COUNTRIES.SOURCE === resource) {
            if (param.data?.flag?.rawFile === undefined) {
               delete param.data.flag;
               return Api.UpdateItem(PathCreator.COUNTRIES_PATH+'/edit' , param);
            }
            
            return convertFileToBase64(param.data?.flag).then((base64Picture) => {
               param.data.flag = base64Picture;
               return Api.UpdateItem(PathCreator.COUNTRIES_PATH+'/edit' , param);
            });
         } 
         
         if (CITIES.SOURCE === resource) {
            return Api.UpdateItem(PathCreator.CITIES_PATH+'/edit' , param);
         }
         if (SMS_PROVIDERS.SOURCE === resource) {
            return Api.UpdateItem(PathCreator.SMS_PROVIDERS_PATH+'/edit' , param);
         }
         if (ADMIN_USER_CREDENTIALS.SOURCE === resource) {
            return Api.UpdateItem(PathCreator.ADMIN_USER_CREDS_PATH+'/edit' , param);
         }
         if (AREAS.SOURCE === resource) {
            return Api.UpdateItem(PathCreator.AREAS_PATH+'/edit' , param);
         }
         if (CURRENCIES.SOURCE === resource) {
            return Api.UpdateItem(PathCreator.CURRENCIES_PATH+'/edit' , param);
         } 
         if (IP_LISTS.SOURCE === resource) {
            return Api.UpdateItem(PathCreator.IP_LISTS_PATH+'/edit' , param);
         }
         if (STYLE_POST.SOURCE === resource) {
            return convertAllToBase64(param, Api.UpdatePost, PathCreator.STYLIST_PATH).then(() => {
               Api.updateStylePostState(PathCreator.USERS_PATH, param);
            });
         }
         if(SNAPSHOT.SOURCE === resource) {
            getHashTags(param);
            return convertAllToBase64(param, Api.UpdateSnapshots, PathCreator.SNAPSHOT_PATH);
         }
         if (CAMPAIGN.SOURCE === resource) {
            return Api.UpdateCampaign(PathCreator.CAMPAIGN_PATH, param);
         }
         if (VERSION.SOURCE === resource) {
            return Api.UpdateAdminVersion(PathCreator.ADMIN_VERSION_PATH, param);
         } 
         if (IP_LIST_CONFIG.SOURCE === resource) {
            return Api.UpdateItem(PathCreator.IP_LIST_CONFIG_PATH, param);
         }        
         if (SETTINGS.SOURCE === resource) {
            return Api.UpdateItem(PathCreator.SETTINGS_PATH, param);
         }        

         if (COLUMN_HAIR_SERVICE.SOURCE === resource) {
            return Api.UpdateItem(PathCreator.COLUMN_HAIR_SERVICE_PATH, param);
         }

         if (COLUMN_CATEGORY.SOURCE === resource) {
            if (param.data?.image?.rawFile === undefined) {
               delete param.data.image;
               return Api.UpdateItem(PathCreator.COLUMN_CATEGORY_PATH, param);
            }
            return convertFileToBase64(param.data?.image).then((base64Picture) => {
               param.data.image = base64Picture;
               return Api.UpdateItem(PathCreator.COLUMN_CATEGORY_PATH, param);
            });
         }

         if (COLUMN.SOURCE === resource) {
            if(param.data.author_photo && param.data.author_photo.rawFile) {
               return convertFileToBase64(param.data.author_photo).then((base64Picture) => {
                  param.data.author_photo = base64Picture;
                  return convertAllToBase64(param, Api.UpdateItem, PathCreator.COLUMN_PATH);
               })
            }
            param.data.author_photo = param.data.author_photo.author_photo;
            return convertAllToBase64(param, Api.UpdateItem, PathCreator.COLUMN_PATH);
         }

         if (HASHTAG_CATEGORY_LIST.SOURCE === resource) {
            if (param.data?.image?.rawFile === undefined || param.data?.image === undefined) return Api.UpdateItem(PathCreator.GetPathBySource(resource), param);
            return convertFileToBase64(param.data?.image).then((base64Picture) => {
               param.data.image = base64Picture;
               return Api.UpdateItem(PathCreator.GetPathBySource(resource), param);
            });
         }

         if (USER.USER_CONTACT === resource) {
            return Api.UpdateItem(PathCreator.GetPathBySource(resource), param);
         }
         if (HASHTAG_CATEGORY.SOURCE === resource) {
            if (param.data?.image?.rawFile === undefined || param.data?.image === undefined) return Api.UpdateItem(PathCreator.GetPathBySource(resource), param);
            return convertFileToBase64(param.data?.image).then((base64Picture) => {
               param.data.image = base64Picture;
               return Api.UpdateItem(PathCreator.GetPathBySource(resource), param);
            });
         }
         if (USER.SOURCE === resource || USER.STYLIST_SOURCE === resource) {
            if (param.data.background_photo) delete param.data.background_photo;
            if (param.data?.profile_photo) {
               if (param.data?.profile_photo?.rawFile)
                  return convertFileToBase64(param.data?.profile_photo).then((base64Picture) => {
                     param.data.profile_photo = base64Picture;
                     return Api.UpdateItem(PathCreator.GetPathBySource(resource), param);
                  });
               else {
                  param.data.profile_photo = param.data.profile_photo.image;
                  return Api.UpdateItem(PathCreator.GetPathBySource(resource), param);
               }
            }
         }
         if (KEYWORDS.SOURCE === resource) {
            return Api.UpdateAdminVersion(PathCreator.GetPathBySource(resource), param);
         }

         return Api.UpdateItem(PathCreator.GetPathBySource(resource), param);
      }
      //   case GET_MANY: {
      //      let param = params as UpdateParams;
      //      return Api.UpdateItem(PathCreator.GetPathBySource(resource), param);
      //   }
      default: {
      }
   }
   return Promise.reject(new HttpError('Unsupported Data Provider request type', 405));
};

const convertHTTPResponseToDataProvider = (response: AxiosResponse, type: string, resource: string, params: Params) => {
   if (resource === 'version') {
      return {data: response.data};
   }
   switch (type) {
      case EXPORT_LIST: {
         return {
            data: response.data
         };
      }
      case GET_MANY_REFERENCE: {
         const dataList = response.data.data ? response.data.data : (response.data as Array<Object>);
         if (resource === STYLE_POST.SOURCE) {
            const formatedData: Array<Object> = dataList.data.map((item, index) => {
               item[STYLE_POST.related_user_id] = (params as any).id;
               return item;
            });
            return {
               data: formatedData,
               total: dataList.total
            };
         }
         if (resource === REPORTS.SOURCE) {
            return {
               data: dataList,
               total: response.data.total
            };
         }
         if (resource === SERVICES.SOURCE) {
            return {
               data: dataList,
               total: response.data.total
            };
         }
         if (resource === CITIES.SOURCE) {
            return {
               data: dataList,
               total: response.data.total
            };
         }
         if (resource === SMS_PROVIDERS.SOURCE) {
            return {
               data: dataList,
               total: response.data.total
            };
         }
         if (resource === AREAS.SOURCE) {
            return {
               data: dataList,
               total: response.data.total
            };
         }
         break;
      }
      case GET_LIST: {
         const dataList = response.data.data ? response.data.data : (response.data as Array<Object>);

         if (resource === CAMPAIGN.SOURCE) {
            return {
               data: [dataList],
               total: 1
            };
         }

         if (resource === NOTIFICATIONS.SOURCE) {
            const notifications = dataList['notifications']['data'];
            notifications.map((item) => {
               const arr = item.message.split(':');
               item.title = arr[0];
               item.message = arr[1];
               return item;
            });
            return {
               data: notifications,
               total: dataList['notifications']['total']
            };
         }

         if (resource === HASHTAGS_LIST_TYPES.SOURCE) {
            const formatedData: Array<Object> = dataList.map((item, index) => {
               let obj = {};
               obj[HASHTAGS_LIST_TYPES.id] = item;
               obj[HASHTAGS_LIST_TYPES.name] = item;
               return obj;
            });
            return {
               data: formatedData,
               total: formatedData.length
            };
         }
         if (resource === HASHTAG_MULTIPLE_LIST.SOURCE) {
            return {
               data: dataList,
               total: response.data.total ? response.data.total : dataList.length
            };
         }

         if (resource === COLUMN.SOURCE) {
            const formatedData: Array<Object> = dataList.map((item, index) => {
               let obj = Object.assign({}, item);
               if (Array.isArray(item.images)) obj[COLUMN.thumbnail_image] = item.images[0]?.image;
               return obj;
            });
            return {
               data: formatedData,
               total: response.data.total
            };
         }
         const isArray = Array.isArray(dataList);
         return {
            data: isArray ? dataList : [],
            total: response.data.total ? response.data.total : dataList.length
         };
      }
      case GET_MANY: {
         return {
            data: response.data.data
         };
      }
      case GET_ONE: {
         if (resource === NOTIFICATIONS.SOURCE) {
         }

         if (resource === SALON.SOURCE) {
            return {
               data: {...response.data.data, id: (params as GetOneParams).id, salon_id: response.data.data.id}
            };
         }
         if (resource === USER.SOURCE) {
            return {
               data: {...response.data.data, id: (params as GetOneParams).id}
            };
         }
         if (resource === STYLE_POST.SOURCE) {
            return {
               data: {...response.data.data, is_published: response.data.data.state !== "blocked", id: (params as GetOneParams).id}
            };
         }
         if (resource === USER.STYLIST_SOURCE) {
            return {
               data: {...response.data.data, id: (params as GetOneParams).id}
            };
         }
         // let param = params as GetOneResult;
         return {
            data: response.data
         };
      }
      case DELETE: {
         let param = params as DeleteParams;
         return {
            data: {id: param.id}
         };
      }
      case CREATE:
      case UPDATE: {
         let param = params as UpdateParams;
         return {
            data: param.data
         };
      }
      default: {
         return {
            data: response.data
         };
      }
   }
};

const parseErrors = (axiosError: AxiosError) => {
   const {message} = axiosError;
   const {errors = undefined} = {...axiosError?.response?.data};

   let messageResult = '';
   if (!errors) return message;
   if (typeof errors === 'string') return errors;
   const keys = Object.keys(errors || {});
   if (keys.length === 0) return message;
   keys.forEach((key) => {
      messageResult += errors[key] + ' ';
   });

   return messageResult;
};
export default (type: string, resource: any, params: Params) => {
   return convertDataProviderRequestToHTTP(type, resource, params)
      .then((response) => convertHTTPResponseToDataProvider(response, type, resource, params))
      .catch((error: AxiosError) => {
         if (error !== undefined) {
            if (error.response?.data?.errors)
               // return Promise.reject(new HttpError(parseErrors(error), error.response?.status, error));
               // const message = error.response?.data?.errors || error.message;
               return Promise.reject(new HttpError(parseErrors(error), error.response?.status, error));
         }
      });
};


function getHashTags(params : CreateParams) {
   if(params.data.description) {
      params.data.tags = params.data.description.match(/(\#+)(\w+)/gi)?.map(item => item.replace("#", ""));
   }
}
